import { render, staticRenderFns } from "./Vuetable.vue?vue&type=template&id=2c4740ea&scoped=true"
import script from "./Vuetable.vue?vue&type=script&lang=js"
export * from "./Vuetable.vue?vue&type=script&lang=js"
import style0 from "./Vuetable.vue?vue&type=style&index=0&id=2c4740ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4740ea",
  null
  
)

export default component.exports